import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { courseApproverReportFilters } from "./courseApproverReportFilters";

function init() {
    setEvents();
}

function setEvents() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(function () {
        let source = $(this).attr("href");

        if (!source.endsWith("?")) {
            source += "?";
        }

        source += $.param(courseApproverReportFilters.getQueryStringFilters());

        $(this).attr("href", source);
    });

    $(document).on("dblclick", "#courseApproverReportTable tbody tr", function () {
        const data =$(this).attr("data-personid");
        if (data === undefined || parseInt(data) < 1) {
            return;
        }
        forms.showSpinner();
        window.location.href = application.baseUrl + "/person/index/" + data;
    });
}

function applyFilters() {
    forms.showSpinner();
    getData().then(function (data) { 
        $("#courseApproverReportTableWrapper").html(data);
        $("#courseApproverReportTable").DataTable(); 
        forms.hideSpinner();
    });
}

function getData() {
    const filters = courseApproverReportFilters.getFilters();
    return dataaccess.post({ url: "/CourseApproverReport/getCourseApproverReport", data: filters });
}

export const courseApproverReport = {
    init: init
};